import React from "react";

export const Payload = () => (
  <svg
    version="1.1"
    id="Capa_1"
    width="25"
    height="25"
    fill="#fff"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
  >
    <path d="M111.264,70.942l-92.367,49.023c-1.582,0.829-3.076,1.773-4.488,2.806l236.191,123.163l98.905-48.92L111.264,70.942z" />
    <path
      d="M511.954,150.122l-118.163,58.444v65.843c0,8.281-6.714,14.995-14.995,14.995c-8.281,0-14.995-6.714-14.995-14.995V223.4
			l-98.386,48.663v238.295c0.308-0.143,0.62-0.275,0.925-0.427l226.182-114.605C504.538,389.318,512,377.246,512,363.807v-212.36
			C512,151.002,511.97,150.563,511.954,150.122z"
    />
    <path
      d="M492.522,119.927L266.433,5.37l-0.094-0.047c-10.067-5.012-22.029-4.9-32.002,0.3l-91.062,48.329l239.37,126.669
			l115.54-57.147C496.431,122.138,494.548,120.939,492.522,119.927z"
    />
    <path
      d="M0.071,149.117C0.031,149.804,0,150.492,0,151.186v212.881c0,13.162,7.24,25.118,18.896,31.221l215.345,114.292
			l0.097,0.051c0.358,0.187,0.724,0.352,1.087,0.525V271.843L0.071,149.117z"
    />
  </svg>
);
